import apiClient from './apiClient';
import {
  Coupon,
  CouponCreateRequest,
  CouponCreateResponse,
  CouponListResponse,
  CouponSearchParams,
  CouponUpdateRequest,
  CouponUpdateResponse,
  CouponUsage
} from '../types/coupon';
// 外部データベースのAPIエンドポイント（読み取り・書き込み両方）
const BASE_URL = '/external/coupons';
// クーポン一覧を取得
export const getCoupons = async(params: CouponSearchParams = {}): Promise<CouponListResponse> => {
  try {
    const response = await apiClient.get<CouponListResponse>(BASE_URL, { params });
    return response.data;
  } catch (error) {
    console.error('クーポン一覧取得エラー:', error);
    throw error;
  }
};
// 特定のクーポンを取得
export const getCoupon = async(id: number): Promise<Coupon> => {
  try {
    const response = await apiClient.get<Coupon>(`${BASE_URL}/${id}/`);
    return response.data;
  } catch (error) {
    console.error('クーポン詳細取得エラー:', error);
    throw error;
  }
};
// クーポンを作成
export const createCoupon = async(data: CouponCreateRequest): Promise<CouponCreateResponse> => {
  try {
    const response = await apiClient.post<CouponCreateResponse>(`${BASE_URL}/`, data);
    return response.data;
  } catch (error) {
    console.error('クーポン作成エラー:', error);
    throw error;
  }
};
// クーポンを更新
export const updateCoupon = async(id: number, data: CouponUpdateRequest): Promise<CouponUpdateResponse> => {
  try {
    const response = await apiClient.put<CouponUpdateResponse>(`${BASE_URL}/${id}/`, data);
    return response.data;
  } catch (error) {
    console.error('クーポン更新エラー:', error);
    throw error;
  }
};
// クーポンを削除
export const deleteCoupon = async(id: number): Promise<void> => {
  try {
    await apiClient.delete(`${BASE_URL}/${id}/`);
  } catch (error) {
    console.error('クーポン削除エラー:', error);
    throw error;
  }
};

export interface CouponUsageSearchParams {
  page?: number;
  page_size?: number;
  ordering?: string;
}

export interface CouponUsageListResponse {
  count: number;
  next: string | null;
  previous: string | null;
  results: CouponUsage[];
  coupon: Coupon;  // クーポン基本情報を追加
}

export const getCouponUsages = async(couponId: number, params: CouponUsageSearchParams = {}): Promise<CouponUsageListResponse> => {
  try {
    const response = await apiClient.get<CouponUsageListResponse>(`${BASE_URL}/${couponId}/usages/`, { params });
    return response.data;
  } catch (error) {
    console.error('クーポン利用履歴取得エラー:', error);
    throw error;
  }
};
const couponsApi = {
  getCoupons,
  getCoupon,
  createCoupon,
  updateCoupon,
  deleteCoupon,
  getCouponUsages,
};
export default couponsApi;
